"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attributes = void 0;
exports.attributes = {
    borderRadius: {
        small: 5,
        default: 10,
        big: 20
    },
    boxShadow: {
        small: '0 0 46px 0 rgba(0, 0, 0, 0.13)',
        hover: '0 0 15px 0 rgba(0, 0, 0, 0.13)'
    }
};
//# sourceMappingURL=attributes.js.map